import { useEffect, useRef } from 'react';
import '../eu-readiness-shared/hubspot-form.css';

interface Props {
  onSubmitted: (lead: { firstName: string; lastName: string; email: string }) => void;
}

const SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';
const PORTAL_ID = '7030766';
const FORM_ID = 'b96806aa-d30a-4032-97c4-1512e2971175';

const PharmaHubSpotGate = ({ onSubmitted }: Props) => {
  const targetId = useRef(`hs-pharma-gate-${Math.random().toString(36).slice(2, 9)}`);
  const initialized = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const create = () => {
      if (cancelled || initialized.current) return;
      const el = document.getElementById(targetId.current);
      if (!el || !window.hbspt) return;
      el.innerHTML = '';
      window.hbspt.forms.create({
        portalId: PORTAL_ID,
        formId: FORM_ID,
        region: 'na1',
        target: `#${targetId.current}`,
      });
      initialized.current = true;
    };

    const tryLoad = (attempt = 0) => {
      if (cancelled || initialized.current) return;
      if (window.hbspt) { create(); return; }
      if (attempt < 40) setTimeout(() => tryLoad(attempt + 1), 150);
    };

    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`) as HTMLScriptElement | null;
    if (!existing) {
      const s = document.createElement('script');
      s.src = SCRIPT_SRC; s.async = true; s.charset = 'utf-8';
      s.onload = () => tryLoad(0);
      document.body.appendChild(s);
    } else {
      tryLoad(0);
    }

    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || data.type !== 'hsFormCallback') return;
      if (data.eventName !== 'onFormSubmitted') return;
      if (data.id !== FORM_ID) return;
      const values: Array<{ name: string; value: string }> = data.data?.submissionValues
        ? Object.entries(data.data.submissionValues).map(([name, value]) => ({ name, value: String(value ?? '') }))
        : (data.data?.values ?? []);
      const get = (n: string) => values.find(v => v.name === n)?.value ?? '';
      const firstName = get('firstname') || get('firstName');
      const lastName = get('lastname') || get('lastName');
      const email = get('email');
      onSubmitted({ firstName, lastName, email });
    };
    window.addEventListener('message', handleMessage);

    return () => {
      cancelled = true;
      window.removeEventListener('message', handleMessage);
    };
  }, [onSubmitted]);

  return <div className="qbd-hs-form" id={targetId.current} />;
};

export default PharmaHubSpotGate;
